import { appStore } from "../state/store";
import { ProgressBar } from "./ProgressBar";
export class WorkStyleCalibration {
    constructor(app) {
        this.app = app;
        this.choices = { resilience: null, learning: null, collaboration: null };
        // This is now step 3 in a 7-step core onboarding process
        this.progressBar = new ProgressBar(7, 3);
    }
    render() {
        return `
            <div class="card">
                ${this.progressBar.render()}
                <h2>Step 3: Calibrate Your Work Style</h2>
                <p>Your stories tell us <em>what</em> you've achieved. Now, let's quickly calibrate <em>how</em> you approach your work. Choose the statement that feels more like you in each pair.</p>
                
                <form id="workstyle-form">
                    <div class="calibration-section">
                        <h4>Resilience & Execution</h4>
                        <div class="card-pair-container">
                            <div class="choice-card" data-group="resilience" data-choice="push">
                                <p>When a project becomes difficult, my first instinct is to <strong>double down and push through</strong> the obstacle on my own.</p>
                            </div>
                            <div class="choice-card" data-group="resilience" data-choice="pause">
                                <p>When a project becomes difficult, my first instinct is to <strong>pause, reassess, and seek support</strong> or advice from my team.</p>
                            </div>
                        </div>
                    </div>

                    <div class="calibration-section">
                        <h4>Learning & Mastery</h4>
                        <div class="card-pair-container">
                            <div class="choice-card" data-group="learning" data-choice="dive">
                                <p>When facing a new, complex topic, I prefer to <strong>dive in and learn by doing</strong>, figuring things out as I go.</p>
                            </div>
                            <div class="choice-card" data-group="learning" data-choice="guide">
                                <p>When facing a new, complex topic, I prefer to <strong>find a structured guide or mentor</strong> to show me the ropes first.</p>
                            </div>
                        </div>
                    </div>

                    <div class="calibration-section">
                        <h4>Social & Collaboration</h4>
                        <div class="card-pair-container">
                            <div class="choice-card" data-group="collaboration" data-choice="share">
                                <p>In a group discussion, I am most comfortable <strong>sharing my ideas early</strong> to help shape the conversation.</p>
                            </div>
                            <div class="choice-card" data-group="collaboration" data-choice="listen">
                                <p>In a group discussion, I am most comfortable <strong>listening and synthesizing others' ideas</strong> before offering my perspective.</p>
                            </div>
                        </div>
                    </div>

                    <div class="button-container">
                        <button type="submit" class="button-primary" disabled>Next</button>
                    </div>
                </form>
            </div>
        `;
    }
    checkAllSelected() {
        const button = document.querySelector('#workstyle-form button[type="submit"]');
        if (this.choices.resilience && this.choices.learning && this.choices.collaboration) {
            if (button)
                button.disabled = false;
        }
        else {
            if (button)
                button.disabled = true;
        }
    }
    attachEventListeners() {
        const form = document.getElementById('workstyle-form');
        form === null || form === void 0 ? void 0 : form.addEventListener('click', (e) => {
            const target = e.target;
            const card = target.closest('.choice-card');
            if (!card)
                return;
            const group = card.dataset.group;
            const choice = card.dataset.choice;
            this.choices[group] = choice;
            // Update UI
            const cardsInGroup = form.querySelectorAll(`.choice-card[data-group="${group}"]`);
            cardsInGroup.forEach(c => c.classList.remove('selected'));
            card.classList.add('selected');
            this.checkAllSelected();
        });
        form === null || form === void 0 ? void 0 : form.addEventListener('submit', (e) => {
            e.preventDefault();
            if (this.choices.resilience && this.choices.learning && this.choices.collaboration) {
                appStore.updateWorkStyle(this.choices);
                this.app.nextStep();
            }
        });
    }
}
